import { createTheme } from '@mui/material/styles';

export const colors = {
	primary: {
		light: '#cb5e6b',
		main: '#BE3646', // Flush Mahogany color
		dark: '#852531',
		shade4: '#fae7ea', // We Peep color,
		shade5: '#efe0e3',
		shade6: '#cd5968', // for table border
		shade7: '#e1afb5' // watermark
	},
	secondary: {
		light: '#7d8387',
		main: '#5D646A', // Shuttle Gray color
		dark: '#41464a',
		shade4: '#F3F3F4', // Athens Gray color
		shade5: '#7A7C7F',
		shade6: '#E7EAEC', // for table border
		shade7: '#8D8E92', // for table title
		shade8: '#e1e1e1'
	},
	white: {
		main: '#FFFFFF' // White color
	},
	black: {
		main: '#000000', // Black color
		shade2: '#212429' // Shark Black color,
	},
	borderColor: '#E8EBEF',
	boxShadowColor: 'rgb(28 48 74 / 6%)' // Box Shadow
};
export const theme = createTheme({
	palette: {
		primary: {
			light: colors.primary.light,
			main: colors.primary.main,
			dark: colors.primary.dark
		},
		secondary: {
			light: colors.secondary.light,
			main: colors.secondary.main,
			dark: colors.secondary.dark
		},
		text: {
			primary: colors.black.main
		}
	},
	typography: {
		fontFamily: 'Poppins'
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: colors.secondary.main
					}
				}
			}
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					'&.MuiInputBase-root': {
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderColor: colors.secondary.main
						}
					}
				}
			}
		},
		MuiAutocomplete: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
						padding: '6.4px 4px 3.7px 8px'
					}
				}
			}
		}
	}
});
